import { I18nStore } from '@tools/i18n/store';
import { injectTSDI } from '@tools/tsdi';
import * as React from 'react';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('Uncaught error:', error, info);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    render() {
        if (this.state.hasError) {
            const { translate } = injectTSDI(I18nStore);
            if (translate) {
                return (
                    <div>
                        {translate
                            ? translate('commons.error.runtime')
                            : 'Something went wrong'}
                    </div>
                );
            }
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
